export const MEMBERSHIPS_ACTIONS = {
  freeTrial: 'Start Free Trial',
  active: 'Active',
  unavailable: 'Unavailable',
  upgrade: 'Upgrade',
  resubscribe: 'Resubscribe',
  purchasable: 'Buy Now',
};
